import { UserPopupUpdateEmailComponent } from './pages/users/user-popup-update-email/user-popup-update-email.component';
import { DispersionUserComponent } from './pages/dispersions/dispersion-user/dispersion-user.component';
import { MovementsTableComponent } from './pages/movements/movements-table/movements-table.component';
import { UsersTabsComponent } from './pages/users/users-tabs/users-tabs.component';
import { UsersProgramComponent } from './pages/users/users-program/users-program.component';
import { UserRequestComponent } from './pages/user-request/user-request.component';
import { DispersionTabsComponent } from './pages/dispersions/dispersion-tabs/dispersion-tabs.component';
import { DispersionHistoryComponent } from './pages/dispersions/dispersion-history/dispersion-history.component';
import { StpOrdenPagoDefaultComponent } from './pages/stp/stp-ordenPago/stp-ordenPago-default/stp-ordenPago-default.component';
import { StpAbonoDefaultComponent } from './pages/stp/stp-abono/stp-abono-default/stp-abono-default.component';
import { CardNumberPipe } from './shared/pipes/card-number.pipe';
import { ReportIncomeComponent } from './pages/reports/report-income/report-income.component';
import { ApiComponent } from './pages/api/api.component';
import { ApiLogsComponent } from './pages/api/api-logs/api-logs.component';
import { NoteDetailComponent } from './pages/notes/note-detail/note-detail.component';
import { NotesDefaultComponent } from './pages/notes/notes-default/notes-default.component';
import { MovementsDefaultComponent } from './pages/movements/movements-default/movements-default.component';
import { PagosGeneralesComponent } from './pages/pagos-generales/pagos-generales.component';
import { PagosTaeComponent } from './pages/pagos-tae/pagos-tae.component';
import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent } from './shared/components';
import { AuthGuardService, LogedInGuardService } from './shared/services';
import { HomeComponent } from './pages/home/home.component';
import { ReactiveFormsModule } from '@angular/forms';

import {
  DxDataGridModule,
  DxFormModule,
  DxNumberBoxModule,
  DxCheckBoxModule,
  DxSelectBoxModule,
  DxTextBoxModule,
  DxDateBoxModule,
  DxButtonModule,
  DxValidatorModule,
  DxValidationSummaryModule,
  DxTabPanelModule,
  DxMapModule,
  DxSwitchModule,
  DxListModule,
  DxHtmlEditorModule,
  DxLoadIndicatorModule,
  DxTagBoxModule,
  DxBoxModule,
  DxProgressBarModule,
  DxTextAreaModule,
  DxTemplateModule,
  DxValidationGroupModule,
  DxSchedulerModule,
  DxRadioGroupModule,
  DxPieChartModule,
  DxPopupModule,
  DxFileUploaderModule,
  DxScrollViewModule,
  DxFileManagerModule,
  DxDropDownButtonModule,
  DxResponsiveBoxModule,
  DxChartModule,
  DxLoadPanelModule
} from 'devextreme-angular';
import { ProgramsComponent } from './pages/programs/programs.component';
import { CompaniesComponent } from './pages/companies/companies.component';
import { UsersComponent } from './pages/users/users.component';
import { UserDetailComponent } from './pages/user-detail/user-detail.component';
import { CardsComponent } from './pages/cards/cards.component';
import { ProgramComponent } from './pages/program/program.component';
import { DashLayoutComponent } from './layouts';
import { ErrorComponent } from './pages/error/error.component';
import { InputFileComponentComponent } from './pages/input-file-component/input-file-component.component';
// Pipies 
import { NumberToDatePipe } from './shared/pipes/number-to-date.pipe';
import { CompanyComponent } from './pages/companies/form/company.component';
import { DetailComponent } from './pages/companies/detail/detail.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { DispersionsComponent } from './pages/dispersions/dispersions.component';
import { AdminDispersionsComponent } from './pages/admin/dispersions/dispersions.component';
import { DispersionFormComponent } from './pages/dispersions/form/form.component';
import { DispersionDetailComponent } from './pages/dispersions/detail/detail.component';
import { UsersAdminComponent } from './pages/users-admin/users-admin.component';
import { RequestsComponent } from './pages/requests/requests.component';
import { DispersionStatusPipe } from './shared/pipes/dispersion-status.pipe';
import { BalancesComponent } from './pages/balances/balances.component';
import { AdminDispersionDetailComponent } from './pages/admin/dispersions/detail/detail.component';
import { PaymentRequestsComponent } from './pages/payment-requests/payment-requests.component';
import { PaymentRequestsFormComponent } from './pages/payment-requests/form/form.component';
import { NewBeneficiaryComponent } from './pages/payment-beneficiaries/new-beneficiary/new-beneficiary.component';
import { UserDataGuard } from './shared/guards/user-data.guard';
import { ChartPipe } from './shared/pipes/chart.pipe';
import { CmgComponent } from './pages/cmg/cmg.component';
import { CmgFormComponent } from './pages/cmg/form/form.component';
import { DispersionPendingComponent } from './pages/dispersions/dispersion-pending/dispersion-pending.component';
import { DispersionPartialComponent } from './pages/dispersions/dispersion-partial/dispersion-partial.component';
import { DispersionRequestComponent } from './pages/dispersions/dispersion-request/dispersion-request.component';
import { UsersAdminsComponent } from './pages/users/users-admins/users-admins.component';
import { UsersDetailComponent } from './pages/users/users-detail/users-detail.component';
import { InvoiceComponent } from './pages/invoice/invoice.component';
import { LinkUrlPipe } from './shared/pipes/link-url.pipe';
import { SafeUrlPipe } from './shared/pipes/safe-url.pipe';
import { StpOrdenPagoFormComponent } from './pages/stp/stp-ordenPago/stp-ordenPago-form/stp-ordenPago-form.component';
import { ReportCardsComponent } from './pages/reports/report-cards/report-cards.component';

const routes: Routes = [
  {
    path: 'dash',
    component: DashLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      { path: 'home', component: HomeComponent, canActivate: [UserDataGuard]},
      { path: 'programs', component: ProgramsComponent, },
      { path: 'program/:id', component: ProgramComponent, pathMatch: 'full' },
      { path: 'program', component: ProgramComponent, },
      { path: 'cards', component: CardsComponent, },
      { path: 'users/v1', component: UsersComponent, canActivate: [UserDataGuard] },
      { path: 'users', 
        component: UsersTabsComponent, 
        canActivate: [UserDataGuard],
        children: [
          { path: '', redirectTo:'admins', pathMatch: 'full' },
          { path: 'admins', component: UsersAdminsComponent },
          { path: 'program', component: UsersProgramComponent },
        ]
      },
      { path: 'users/detail/:id', component: UsersDetailComponent },
      { path: 'users/:id', component: UsersComponent, pathMatch: 'full' },
      { path: 'users/:programId', component: UsersComponent, pathMatch: 'full' },
      { path: 'user-detail/:programId/:companyId', component: UserDetailComponent, pathMatch: 'full' },
      { path: 'companies', component: CompaniesComponent, canActivate: [UserDataGuard] },
      { path: 'companies/new', component: CompanyComponent, pathMatch: 'full' },
      { path: 'companies/update', component: CompanyComponent, pathMatch: 'full' },
      { path: 'companies/:id', component: CompanyComponent, pathMatch: 'full' },
      { path: 'company', component: DetailComponent, },
      { path: 'company/:id', component: DetailComponent, },
      { path: 'profile', component: ProfileComponent, },
      { path: 'dispersions', component: DispersionsComponent, canActivate: [UserDataGuard] },
      { path: 'dispersions/new', component: DispersionFormComponent, pathMatch: 'full' },
      { path: 'dispersions/edit/:id', component: DispersionFormComponent, pathMatch: 'full' },
      { path: 'dispersions/:id', component: DispersionDetailComponent, pathMatch: 'full' },
      { path: 'admin-users', component: UsersAdminComponent },
      { path: 'requests', component: RequestsComponent, canActivate: [UserDataGuard] },
      { path: 'balances', component: BalancesComponent, canActivate: [UserDataGuard] },
      { path: 'admin/dispersions', component: AdminDispersionsComponent },
      { path: 'admin/dispersions/tabs', 
        component: DispersionTabsComponent ,
        children: [
          { path: 'pendientes', component: DispersionPendingComponent },
          { path: 'parciales', component: DispersionPendingComponent },
          { path: 'solicitudes', component: DispersionPendingComponent },
          { path: 'historial', component: DispersionPendingComponent },
        ],
      },
      { path: 'admin/dispersions/pending', component: DispersionPartialComponent, canActivate: [UserDataGuard] },
      { path: 'admin/dispersions/:id', component: AdminDispersionDetailComponent },
      { path: 'payment-requests', component: PaymentRequestsComponent },
      { path: 'cmg', component: CmgComponent },
      { path: 'cmg/edit/:id', component: CmgFormComponent, pathMatch: 'full' },
      { path: 'cmg/new', component: CmgFormComponent, pathMatch: 'full' },
      { path: 'payment-requests/new', component: PaymentRequestsFormComponent, pathMatch: 'full' },
      { path: 'payment-requests/edit/:id', component: PaymentRequestsFormComponent, pathMatch: 'full' },
      { path: 'payment-beneficiaries/new/:id', component: NewBeneficiaryComponent, pathMatch: 'full' },

      // Movements
      { path: 'movements', component: MovementsDefaultComponent },

      // Movements
      { path: 'pagos-generales', component: PagosGeneralesComponent },
      { path: 'pagos-tae', component: PagosTaeComponent },      

      // Notes
      { path: 'notes', component: NotesDefaultComponent },
      { path: 'notes/detail/:id', component: NoteDetailComponent },

      // STP
      //{ path: 'stp', component: NotesDefaultComponent },
      { path: 'stp/abonos', component: StpAbonoDefaultComponent },
      { path: 'stp/ordenesPago', component: StpOrdenPagoDefaultComponent },
      { path: 'stp/ordenesPago/add', component: StpOrdenPagoFormComponent },

      //Invoces
      { path: 'invoices', component: InvoiceComponent},

      //User requests
      { path: 'user-requests', component: UserRequestComponent},

      // Api
      /*
       { 
         path: 'api', 
         children: [
          { path: '', component: NoteDetailComponent },
          { path: 'docs', component: NotesDefaultComponent },
          { path: 'test', component: NotesDefaultComponent },
          { path: 'logs', component: NoteDetailComponent },
          { path: 'logs', component: NoteDetailComponent },
        ]
      },
      */
      // Api
      { path: 'api' , children: [
        { path: '', pathMatch: 'full', redirectTo : 'logs' },
        { path: 'logs', component: ApiLogsComponent },
      ]},

       // Api
       { path: 'reports' , children: [
        { path: '', pathMatch: 'full', redirectTo : 'cards' },
        { path: 'income', component: ReportIncomeComponent },
        { path: 'cards', component: ReportCardsComponent },
      ]}
      
      

     

    ],
  },
  {
    path: 'log-in',
    component: LoginFormComponent,
    canActivate: [LogedInGuardService],
  },
  { path: 'not-found', component: ErrorComponent },
  { path: '', redirectTo: '/log-in', pathMatch: 'full' },
  { path: '**', redirectTo: '/not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    DxDataGridModule,
    DxFormModule,
    DxDataGridModule,
    DxFormModule,
    DxNumberBoxModule,
    DxCheckBoxModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxButtonModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxTabPanelModule,
    DxMapModule,
    DxSwitchModule,
    DxListModule,
    DxHtmlEditorModule,
    DxLoadIndicatorModule,
    DxTagBoxModule,
    DxBoxModule,
    DxProgressBarModule,
    DxTextAreaModule,
    DxTemplateModule,
    DxValidationGroupModule,
    DxSchedulerModule,
    DxRadioGroupModule,
    DxPieChartModule,
    CommonModule,
    DxPopupModule,
    DxFileUploaderModule,
    DxScrollViewModule,
    ReactiveFormsModule,
    DxFileManagerModule,
    DxDropDownButtonModule,
    DxChartModule,
    DxLoadPanelModule
  ],
  providers: [AuthGuardService, LogedInGuardService],
  exports: [RouterModule],
  declarations: [
    HomeComponent,
    ProgramsComponent,
    CompaniesComponent,
    UsersComponent,
    UserDetailComponent,
    UsersTabsComponent,
    UsersAdminComponent,
    UsersAdminsComponent,
    UsersProgramComponent,
    UsersDetailComponent,
    UserPopupUpdateEmailComponent,
    CardsComponent,
    ProgramComponent,
    ErrorComponent,
    NumberToDatePipe,
    ChartPipe,
    SafeUrlPipe,
    CompanyComponent,
    DetailComponent,
    ProfileComponent,
    DispersionsComponent,
    DispersionTabsComponent,
    DispersionPendingComponent,
    DispersionPartialComponent,
    DispersionRequestComponent,
    DispersionHistoryComponent,
    DispersionUserComponent,
    DispersionFormComponent,
    AdminDispersionsComponent,
    DispersionDetailComponent,
    UsersAdminComponent,
    RequestsComponent,
    DispersionStatusPipe,
    LinkUrlPipe,
    CardNumberPipe,
    BalancesComponent,
    AdminDispersionDetailComponent,
    MovementsDefaultComponent,
    PagosGeneralesComponent,
    PagosTaeComponent,
    MovementsTableComponent,
    NotesDefaultComponent,
    NoteDetailComponent,
    ApiComponent,
    ApiLogsComponent,
    ReportIncomeComponent,
    ReportCardsComponent,
    PaymentRequestsComponent,
    CmgComponent,
    PaymentRequestsFormComponent,
    NewBeneficiaryComponent,
    CmgFormComponent,
    InputFileComponentComponent,
    StpAbonoDefaultComponent,
    StpOrdenPagoDefaultComponent,
    StpOrdenPagoFormComponent,
    InvoiceComponent,
    UserRequestComponent
  ],
})
export class AppRoutingModule { }